import { statusToStr, strToStatus } from '@/_schemas/status-input';

import type { SystemUserFormSchema, SystemUserQuerySchema, SystemUserUpdateSchema } from './schemas';

export function systemUserQueryToForm(data: SystemUserQuerySchema): SystemUserFormSchema {
  return {
    ...data,
    name: data?.name ?? '',
    first_name: data?.first_name ?? '',
    last_name: data?.last_name ?? '',
    email: data?.email ?? '',
    username: data?.username ?? '',
    status: strToStatus(data?.status),

    user_type: data?.user_type ?? '',
    microsoft_groups: data?.microsoft_groups ?? '',
    roles: data?.roles?.[0] ?? null,
  };
}

export function systemUserFormToUpdate({
  status,
  roles,
  profile_images,
  team_member,
  ...rest
}: SystemUserFormSchema): SystemUserUpdateSchema {
  return {
    ...rest,
    status: statusToStr(status),
    roles: roles?.id ? [roles.id] : [],
    profile_images: profile_images?.map((image) => image.id) ?? [],
    team_member_id: team_member?.id ?? null,
  };
}
